import Vue from 'vue'
import VueRouter from 'vue-router'

const MainContainer = () => import('@/components/MainContainer')
const Home = () => import('@/views/Home')
const Impressum = () => import('@/views/Impressum')
const Datenschutz = () => import('@/views/Datenschutz')
const Restaurants = () => import('@/views/Restaurants')
const Restaurant = () => import('@/views/Restaurant')
const Empfehlung = () => import('@/views/Empfehlung')
const Anmeldung = () => import('@/views/Anmeldung')
const Bestellung = () => import('@/views/Bestellung')
const Login = () => import('@/views/Login')
const Register = () => import('@/views/Register')
const Activate = () => import('@/views/Activate')
const Passwordforgot = () => import('@/views/Passwordforgot')
const Profil = () => import('@/views/Profil')
const InHouse = () => import('@/views/InHouse')
// const Facebook = () => import('@/views/Facebook')

Vue.use(VueRouter)

  const routes = [
    {
      path: '/',
      name: 'Home',
      component: MainContainer,
      children: [
        {
          path: '/',
          name: 'Home',
          component: Home
        },
        {
          path: '/login',
          name: 'Login',
          component: Login
        },
        {
          path: '/register',
          name: 'Register',
          component: Register
        },
        {
          path: '/activate',
          name: 'Activate',
          component: Activate
        },
        {
          path: '/profil',
          name: 'Profil',
          component: Profil
        },
        // {
        //   path: '/facebook',
        //   name: 'Facebook',
        //   component: Facebook
        // },
        {
          path: '/passwordforgot',
          name: 'Passwordforgot',
          component: Passwordforgot
        },
        {
          path: '/impressum',
          name: 'Impressum',
          component: Impressum
        },
        {
          path: '/datenschutz',
          name: 'Datenschutz',
          component: Datenschutz
        },
        {
          path: '/my/:id',
          name: 'Restaurant',
          component: Restaurant
        },
        {
          path: '/inhouse/:id',
          name: 'InHouse',
          component: InHouse
        },
        {
          path: '/bestellung/:id',
          name: 'Bestellung',
          component: Bestellung
        },
        {
          path: '/restaurants',
          name: 'Restaurants',
          component: Restaurants
        },
        {
          path: '/empfehlung',
          name: 'Empfehlung',
          component: Empfehlung
        },
        {
          path: '/anmeldung',
          name: 'Anmeldung',
          component: Anmeldung
        },
      ]
    },

    // {
    //   path: '/',
    //   name: 'Restaurants',
    //   component: MainContainer,
    //   children: [
        
        
    //   ]
    // },
  {
    path: '*', 
    beforeEnter: (to, from, next) => {
      next('/home')
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
